import React from "react";
import {SvgIcon, SvgIconProps} from "@material-ui/core"


const CloseIcon = (props: SvgIconProps) => {
    return (
        <SvgIcon {...props}>
            <svg version="1.1" id="Layer_1" x="0px" y="0px"
                 viewBox="0 0 1500 1500">
                <g id="Ellipse_40">
                    <g>
                        <circle fill="#FFFFFF" cx="749.685" cy="750.327" r="749.673"/>
                    </g>
                    <g>
                        <path fill="#707070" d="M749.673,1499.966C336.31,1499.966,0,1163.657,0,750.339C0,336.976,336.31,0.666,749.673,0.666
			c413.409,0,749.719,336.31,749.719,749.673C1499.391,1163.657,1163.082,1499.966,749.673,1499.966z M749.673,47.521
			c-387.557,0-702.818,315.262-702.818,702.818c0,387.511,315.262,702.772,702.818,702.772
			c387.602,0,702.864-315.262,702.864-702.772C1452.537,362.783,1137.275,47.521,749.673,47.521z"/>
                    </g>
                </g>
                <g id="Group_322" transform="translate(4 4)">
                    <g id="Line_17">

                        <rect x="722.271" y="216.218"
                              transform="matrix(0.7071 -0.7071 0.7071 0.7071 -309.3162 745.9419)" fill="#707070"
                              width="46.85" height="1060.198"/>
                    </g>
                    <g id="Path_531">
                        <path d="M1120.521,371.491l-749.673,749.673"/>

                        <rect x="215.597" y="722.892"
                              transform="matrix(0.7071 -0.7071 0.7071 0.7071 -309.3161 745.8775)" fill="#707070"
                              width="1060.198" height="46.85"/>
                    </g>
                </g>
                <g>
                </g>
                <g>
                </g>
                <g>
                </g>
                <g>
                </g>
                <g>
                </g>
                <g>
                </g>
                <g>
                </g>
                <g>
                </g>
                <g>
                </g>
                <g>
                </g>
                <g>
                </g>
                <g>
                </g>
                <g>
                </g>
                <g>
                </g>
                <g>
                </g>
            </svg>
        </SvgIcon>
    )
};

export default CloseIcon;